export default {
  businessName: 'company',
  firstName: 'firstname',
  lastName: 'lastname',
  email: 'email',
  igniteFirstName: 'ignite_first',
  igniteLastName: 'ignite_last',
  igniteEmail: 'ignite_email',
  postalCode: 'zip_code',
  phone: 'phone',
  userId: 'ignite_c_id',
  guideId: 'ignite_guide_id'
}
